import T from '../../../../common/components/T';
import { svgSprite } from '../../../../hybrid/wrappers';
import css from './Activity.module.scss';

export default function Activity({ val }) {
    return (
        <div className={css.wrapper}>
            <div className={css.icon}>
                {svgSprite(val ? 'check-activity-colored' : 'cross-activity-colored', { className: css.svg })}
            </div>
            <p className={css.text}>
                {val ? <T textName='active' defaultStr='Активен' /> : <T textName='unactive' defaultStr='Не активен' />}
            </p>
        </div>
    );
}
